import React from 'react';

export interface IShowLoadingContextType {
  showLoading: boolean;
  setShowLoading: (showLoading: boolean, loadingText?: string) => void;
}

// Allows Header to hide search bar when book is being viewed in DiscoverBook.tsx
export const ShowLoadingContext = React.createContext<IShowLoadingContextType>({
  showLoading: true,
  setShowLoading: () => {}
});
